<template>
    <div v-if="site">
         <div class="component-all ">
            <div class=" primary--text component-select">
                <v-checkbox
                    v-model = "warranty"
                    :ripple = "false"
                    class   = "component-checkbox"
                    @click  = "onSelectAll"
                    hide-details
                    style="padding-top: 0"
                    dense
                />

                <div class="primary--text">{{ $t('inc.edit.invoice.allComponents') }}</div>
            </div>
            <div class="component-date white" style="margin-top: 3px;">
                <f-date-picker
                    v-model       = "warrantyDate"
                    :time         = "false"
                    :hide-details = "true"
                    class="primary--text mt-0 pt-0"
                    @change       = "onInput"
                    dense
                />
            </div>
        </div>

        <div class="component-list">
            <div
                v-for = "(component, index) in site.components"
                :key  = "index"
                class = "pb-2 pb-0 pt-0"
            >
                <v-row class="no-frame mb-0 pl-0 pt-0" :class="index === 0 ? 'pt-2' : ''">
                    <!-- Warrenty Checkbox -->
                    <div class="pt-0 " style="width: calc(100% - 110px)">
                        <div class="component-name">
                            <v-checkbox
                                v-model = "component.warranty"
                                :ripple = "false"
                                class   = "component-checkbox pt-0"
                                @click  = "onSelect(component)"
                                hide-details
                                dense
                            />
                            {{ component.component.name }}
                        </div>
                    </div>
                    <!-- Warrenty Checkbox -->

                    <!-- Icon Repair vs. change -->
                    <div class="pt-0 component-name" style="width: 20px">
                        <v-icon :color="component.warranty ? 'primary' : 'lightgray'">
                            {{ icon(component) }}
                        </v-icon>
                    </div>
                    <!-- Icon Repair vx. change -->

                    <!-- Warrenty date -->
                    <div class="component-date">
                        <!-- ... if selected -->
                        <f-date-picker
                            v-if          = "component.warranty"
                            v-model       = "component.warrantyDate"
                            :time         = "false"
                            :hide-details = "true"
                            dense
                        />
                        <!-- ... if selected -->

                        <!-- ... if not selected -->
                        <div
                            v-if="!component.warranty"
                            class="component-date-not-selected"
                        >
                            <v-icon size="20" color="lightgray">mdi-close</v-icon>
                        </div>
                        <!-- ... if not selected -->
                    </div>
                    <!-- Warrenty date -->
                </v-row>
            </div>
        </div>
    </div>
</template>

<script>

import Inc from "@/modules/inc/service/Inc";
import FDatePicker from "@/modules/core/components/utils/FDatePicker.vue";

export default {
    name: "IncWarrantyEdit",

    components: {
        FDatePicker
    },

    props: {
        site: {

        }
    },

    data: () => ({
        warrantyDate : null,
        warranty     : false
    }),

    methods: {
        icon (component) {
            return Inc.component.icon(component);
        },

        onSelect (component) {
            if (!component.warranty) {
                this.warrantyDate = null;
            }

            if (component.warranty && !component.warrantyDate) {
                component.warrantyDate = this.warrantyDate;
            }
        },

        onSelectAll () {
            this.site.components.forEach(c => {
                c.warranty = this.warranty;
                if (c.warranty && !c.warrantyDate) {
                    c.warrantyDate = this.warrantyDate;
                }
            });
        },

        onInput (value) {
            this.site.components.forEach(c => {
                if (c.warranty && !c.warrantyDate) {
                    c.warrantyDate = value;
                }
            });
        }
    }
}
</script>

<style scoped>

.component-name {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    padding-top: 2px;
    padding-bottom: 3px;
}

.component-name,
.component-select,
.component-date-not-selected {
    display: flex;
    border-bottom-width: 1px;
    border-bottom-color: lightgray;
    border-bottom-style: dotted;
}


.component-all {
  /*
    background-color: #f5f5f5;

   */
    height: 30px;
    display: flex;
}

.component-select {
    padding-top: 2px;
    width: calc(100% - 90px);
}

.component-checkbox {
    margin-left: -5px;
    margin-top: 0px;
}

.component-date {
    width: 90px;
    padding-left: 10px;
}

.component-date-not-selected {
    text-align: center!important;
    padding-top: 3px;
    padding-bottom: 3px;
}

.component-date-not-selected i {
    padding-left: 30px;
    margin-top: 4px;
}

.component-list {
    min-height: 125px;
    max-height: 230px;
    overflow-y: scroll;
    width: calc(100% + 10px);
}


</style>